<!-- Blood Report History Screen -->
<div class="blood-history-screen" *ngIf="showBloodReportHistory">
  <div class="blood-history-header">
    <button class="back-btn" type="button" (click)="showBloodReportHistory = false">
      <span class="back-arrow">←</span>
      <span class="back-text">Back</span>
    </button>
  </div>
  <app-blood-report-history [memberId]="memberId"></app-blood-report-history>
</div>

<div
  class="health-tools-section mt-4"
  *ngIf="memberDetail && memberDetail.firstName && !showBloodReportHistory"
>
  <div class="health-tools-grid">
    <div class="health-tool-card">
      <div class="tool-icon blood-report-icon">
        <img
          src="assets/img/Blood report extraction.png"
          alt="Blood Report Icon"
        />
      </div>
      <div class="tool-content">
        <h3 class="tool-title blood-report-title">Blood Report Analyzer</h3>
        <p class="tool-description">
          Easily interpret lab values and identify key health markers.
        </p>
        <div style="display: flex; gap: 8px;">
          <button class="tool-button" (click)="openBloodReportTool()">
            Open
          </button>
          <button class="tool-button tool-button-history" (click)="showBloodReportHistory = true">
            View History
          </button>
        </div>
      </div>
    </div>

    <div class="health-tool-card">
      <div class="tool-icon glucose-data-icon">
        <img
          src="assets/img/Glucose Data Extraction.png"
          alt="Glucose Data Icon"
        />
      </div>
      <div class="tool-content">
        <h3 class="tool-title glucose-data-title">Upload CGM Graphs</h3>
        <p class="tool-description">
          Seamlessly extract and organize glucose readings for deeper insights.
        </p>
        <button class="tool-button" (click)="openGlucoseDataTool()">
          Open
        </button>
      </div>
    </div>

    <div class="health-tool-card">
      <div class="tool-icon biweekly-report-icon">
        <img src="assets/img/BiweeklyReport.png" alt="Biweekly Report Icon" />
      </div>
      <div class="tool-content">
        <h3 class="tool-title biweekly-report-title">Biweekly Report</h3>
        <p class="tool-description">
          Track health trends with automated biweekly summaries.
        </p>
        <div style="display: flex; gap: 8px">
          <button class="tool-button" (click)="openBiweeklyReportTool()">
            Open
          </button>
          <button
            *ngIf="latestBiweeklyReport"
            class="tool-button tool-button-recent-report"
            (click)="openLastGeneratedReport()"
          >
            Latest BW
          </button>
        </div>
      </div>
    </div>

    <div class="health-tool-card">
      <div class="tool-icon grocery-list-icon">
        <img src="assets/img/GroceryList.png" alt="Grocery List Icon" />
      </div>
      <div class="tool-content">
        <h3 class="tool-title grocery-list-title">Grocery List Generator</h3>
        <p class="tool-description">
          Generate personalized shopping lists based on your meal plan.
        </p>
        <div style="display: flex; gap: 8px">
          <ng-container *ngIf="!groceryCompleted; else groceryDownloadSection">
            <button
              class="tool-button"
              [disabled]="groceryProcessing"
              (click)="openExistingGroceryList()"
            >
              Open existing
            </button>
            <button
              class="tool-button secondary"
              [disabled]="groceryProcessing"
              (click)="openGroceryListTool()"
            >
              Create new
            </button>
          </ng-container>
          <ng-template #groceryDownloadSection>
            <button
              class="tool-button"
              [disabled]="groceryProcessing || groceryButtonText === 'Downloading...'"
              (click)="downloadGroceryPDF()"
            >
              {{ groceryButtonText }}
            </button>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="health-tool-card">
      <div class="tool-icon grocery-list-icon">
        <img src="assets/img/restaurantIcon.png" alt="Restaurant Icon" />
      </div>
      <div class="tool-content">
        <h3 class="tool-title grocery-list-title">Favorite Restaurants</h3>
        <p class="tool-description">My favorite restaurants list.</p>
        <div style="display: flex; gap: 8px">
          <button
            class="tool-button"
            [disabled]="favoriteRestaurantsLoading"
            (click)="openFavoriteRestaurants()"
          >
            {{ favoriteRestaurantsLoading ? "Loading..." : "Open" }}
          </button>
          <button
            class="tool-button secondary"
            (click)="openAddRestaurantDialog()"
          >
            Add to Favorite
          </button>
        </div>
      </div>
    </div>

    <div class="health-tool-card">
      <div class="tool-icon nutrition-score-icon">
        <img src="assets/img/Nutrition Score.png" alt="Heald Nutrition Score Icon" />
      </div>
      <div class="tool-content">
        <h3 class="tool-title nutrition-score-title">Heald Nutrition Score</h3>
        <p class="tool-description">
          View nightly and current-day nutrition scores for this member.
        </p>
        <div style="display: flex; gap: 8px">
          <a
            class="tool-button tool-button-link"
            [href]="generateNightlyNutritionScoreUrl()"
            target="_blank"
            rel="noopener noreferrer"
          >
            Nightly Score
          </a>
          <a
            class="tool-button secondary tool-button-link"
            [href]="generateCurrentDayNutritionScoreUrl()"
            target="_blank"
            rel="noopener noreferrer"
          >
            Current Day Score
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
